/* eslint-disable jsx-a11y/iframe-has-title */
import {Card, CardHeader, CardBody, Progress, Divider} from "@nextui-org/react";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";

const ContactPage = () => {
    const {t} = useTranslation()

    useEffect(() => {
        // LocalBusiness schema
        const schema = {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Oil Trans",
            "image": "logo_url",
            "telephone": "+90 530 244 94 23",
            "email": "ramazan.zelan@oiltrans.com.tr",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ankara",
                "addressCountry": "TR"
            },
            "openingHours": "Mo-Fr 09:00-17:00"
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(schema);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return(
        <div>
            

            <section className="bg-white pb-6 dark:bg-gray-900 bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern.svg')] dark:bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern-dark.svg')]">
                <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 z-10 relative">
                
                    <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">{t("contact")}</h1>
                <div className={"text-center flex justify-center my-5"}>
                    <Progress
                        size="sm"
                        color={"warning"}
                        isIndeterminate
                        aria-label="Loading..."
                        className="max-w-md"
                    />
                </div>
                    <p className="mb-8 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 lg:px-48 dark:text-gray-200">
                    {t("contactDesc")}
                    </p>
                    <Divider className="my-4" />

                    
                    
                
                </div>
                <div className={"mt-20 pb-20 mx-5 sm:mx-auto sm:container"}>
                    <div className={"grid grid-cols-12 items-center"}>
                        <div className={"col-span-12 sm:col-span-5"}>
                            <iframe className={"border-none w-full rounded-xl"} src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3775.963784106614!2d42.066830887867376!3d37.2411534324343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzfCsDE0JzI4LjEiTiA0MsKwMDQnMDUuOSJF!5e1!3m2!1str!2str!4v1738015202319!5m2!1str!2str" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        
                        <div className={"col-span-12 sm:col-span-7 mx-10"}>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-20 sm:mt-0">
                                <div className="col-span-1">
                                    <Card className="py-4">
                                        <CardHeader className="pb-0 pt-2 px-4 flex-col items-center">
                                            <i className="fa-solid text-primary fa-phone-volume text-center" style={{fontSize:"8rem"}}></i>
                                        </CardHeader>
                                        <CardBody className="overflow-visible py-2 text-center mt-5">
                                            <p className="text-tiny uppercase font-bold">{t("phone")}</p>
                                            <small className="text-default-500">{t("activeHours")}</small>
                                            <h4 className="font-bold text-large">+90 530 244 94 23</h4>
                                        </CardBody>
                                    </Card>
                                </div>
                                
                                <div className="col-span-1">
                                    <Card className="py-4">
                                        <CardHeader className="pb-0 pt-2 px-4 flex-col items-center">
                                            <i className="fa-solid fa-envelope text-primary text-center" style={{fontSize:"8rem"}}></i>
                                        </CardHeader>
                                        <CardBody className="overflow-visible py-2 text-center mt-5">
                                            <p className="text-tiny uppercase font-bold">{t("email")}</p>
                                            <small className="text-default-500">{t("activeHours")}</small>
                                            <h4 className="font-bold text-sm">ramazan.zelan@oiltrans.com.tr</h4>
                                        </CardBody>
                                    </Card>
                                </div>
                                
                                <div className="col-span-1">
                                    <Card className="py-4">
                                        <CardHeader className="pb-0 pt-2 px-4 flex-col items-center">
                                            <i className="fa-solid fa-address-card text-primary text-center" style={{fontSize:"8rem"}}></i>
                                        </CardHeader>
                                        <CardBody className="overflow-visible py-2 text-center mt-5">
                                            <p className="text-tiny uppercase font-bold">{t("contactCard")}</p>
                                            <small className="text-default-500">{t("businessHours")} Ramazan ZELAN - Oiltrans Muhasebe Personeli</small>
                                            <h4 className="font-bold text-sm">{t("getInTouch")}</h4>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    </div>
                <div className="bg-gradient-to-b from-orange-200 to-transparent dark:from-orange-950 w-full dark:h-[40rem] absolute top-0 left-0 z-0"></div>
            </section>
            
            
        </div>
        )
    
}

export default ContactPage;